module.exports = __webpack_public_path__ + "img/how works.48832c35.svg";